import { createContext } from 'react';

export interface ModalMethods {
  open: () => void;
  close: () => void;
  toggle: () => void;
  hasBeenOpened: () => boolean;
}

export type ModalRecordInterface = Record<string, ModalMethods>;

export interface ModalContextInterface {
  setModal: (modalName: string, methods: ModalMethods) => null;
  getModal: (modalName: string) => ModalMethods | undefined;
  deleteModal: (modalName: string) => void;
  modals: Record<string, ModalMethods>;
}

const defaultContext = {
  modals: {},
  setModal: () => null,
  getModal: () => undefined,
  deleteModal: () => null,
};

export const ModalContext = createContext<ModalContextInterface>(defaultContext);
